import React, { useMemo } from "react";
import PT from "prop-types";
import { CircleButton } from "_c/button";
import { useCloudinaryWidget } from "@/hooks/useCloudinaryWidget";
import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { MAX_PHOTOS_PER_TASK } from "@/misc/constants";
import { ORDERS_NS } from "@/i18n/ns";
import Info from "_c/atoms/Info";
import PlusIcon from "_c/icon/Plus";
import { PortfolioService } from "@/services/Portfolio";
import { useMut } from "@/hooks/useMut";

const ns = `${ORDERS_NS}:add_photo_form`;
const Upload = ({ t, ...props }) => {
  const authUserId = useSelector(UserSelectors.getUserId);
  const postedPhotosCount = useMemo(() => {
    return props.photos.reduce((acc, { creator }) => {
      return creator === authUserId ? acc + 1 : acc;
    }, 0);
  }, [props.photos, authUserId]);

  const limit = Math.max(0, MAX_PHOTOS_PER_TASK - postedPhotosCount);
  const isMax = limit <= 0;
  const { uploadPhoto: uploadPhotoToCloudinary } = useCloudinaryWidget();
  const mut = useMut(
    async (photo) => {
      const as = props.isTaskMaster
        ? "master"
        : props.isTaskConsumer
        ? "client"
        : "saloon";
      const payload = {
        as,
        task: props.task._id,
        master: props.task.master,
        photo,
        ...(props.task.consumer && {
          client: props.task.consumer,
        }),
        ...(props.task.saloon && {
          saloon: props.task.saloon,
        }),
      };
      await PortfolioService.createPhoto(payload, {
        taskRestPhotos: props.photos,
      });
    },
    {
      t,
      notifyOnError: true,
    }
  );
  const onSubmit = async () => {
    const photo = await uploadPhotoToCloudinary();
    if (!photo) return;
    mut.mutate(photo);
  };
  return (
    <>
      <Info isError={isMax}>
        {isMax ? t(`${ns}.max_warn`) : t(`${ns}.max_tip`, { limit })}
      </Info>
      <CircleButton
        aria-label={t("common:add_photo")}
        type="button"
        centered
        onClick={onSubmit}
        large
        disabled={isMax || mut.isLoading}
        greenish
      >
        <PlusIcon color="white" />
      </CircleButton>
    </>
  );
};
Upload.propTypes = {
  photos: PT.array.isRequired,
  isTaskMaster: PT.bool,
  isTaskConsumer: PT.bool,
  task: PT.object.isRequired,

  t: PT.func.isRequired,
};
export default Upload;
